<template>
  <section class="app-section-base">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="title">
            <h3><span>Jobs</span></h3>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-sm-6 col-md-4">
          <div class="thumbnail app-job-search-grid">
            <div class="caption">
              <h4 style="text-align:center;">Care Service Manager</h4>
              <p>
                The role will be to support with the smooth running and provide
                management skills covering our services across 5 locations.
              </p>
              <div class="app-more-info-wrapper">
                <button
                  @click="showMoreJobDetails(1)"
                  type="button"
                  class="btn btn-primary btn-lg"
                >
                  Read more...
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4">
          <div class="thumbnail app-job-search-grid">
            <div class="caption">
              <h4 style="text-align:center;">Senior Support Team Leader</h4>
              <p>
                The role will be to help supervise a team of support workers in
                our service across 5 locations.
              </p>
              <div class="app-more-info-wrapper">
                <button
                  @click="showMoreJobDetails(2)"
                  type="button"
                  class="btn btn-primary btn-lg"
                >
                  Read more...
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4">
          <div class="thumbnail app-job-search-grid">
            <div class="caption">
              <h4 style="text-align:center;">
                Care Assistant / Support Worker
              </h4>
              <p>
                To provide care and support to OTANG CARE Service Users in line
                with the company's aim to provide a high quality, reliable
                support service tailored to suit each of our Service Users'
                individual care plans and to promote their independence and
                choice.
              </p>
              <div class="app-more-info-wrapper">
                <button
                  @click="showMoreJobDetails(3)"
                  type="button"
                  class="btn btn-primary btn-lg"
                >
                  Read more...
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  //   data() {
  //     return {
  //       showAnimation: false,
  //       alertMessage: "",
  //     };
  //   },
  methods: {
    showMoreJobDetails: function(value) {
      this.$router.push({ name: "job-details", params: { id: value } });
    },
  },
};
</script>
<style>
.app-job-search-grid {
  min-height: 260px;
}
.app-more-info-wrapper {
  text-align: center;
  padding-top: 20px;
}
</style>
